<template>
  <div class="ElementUIS">
    <section>
      <!--系统公告跳转列表-->
      <!--ElementUI+分页+过滤+表格  -->
      <!--el-form是过滤条件  -->
      <el-form :inline="true" :model="filter" @submit.native.prevent class="inline">
        <span class="span">{{moreannouncement}}</span>
        <div class="link-top1"></div>
        <el-form-item :label="type" class="typelabel">
          <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="time" class="time">
          <el-date-picker
            v-model="filter.publish_time"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="pubdate"
          ></el-date-picker>
        </el-form-item>
        <div class="link-top2"></div>
      </el-form>
      <el-pagination
        layout="total, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="15"
        :total="tableData.length"
        style="float:right;"
      ></el-pagination>
      <el-table
        :data="pageData"
        :row-style="{height:'20px'}"
        :cell-style="{padding:'0px'}"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        :default-sort="{prop: 'date', order: 'descending'}"
        style="width: 100%;border:0;font-size: 12px;"
      >
        <el-table-column type="index" label=" "></el-table-column>
        <el-table-column prop="status" :label="state" width="130" class="stat">
          <!-- 自定义样式 -->
          <template slot-scope="scope">
            <span
              style="padding:'0px'"
              :title="scope.row.status.value"
              :class="addclassStatus(scope.row.status.num)"
            >{{ scope.row.status.value }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="noticeName" :label="title" width="430" show-overflow-tooltip></el-table-column>
        <el-table-column prop="org" :label="puborg" width="230"></el-table-column>
        <el-table-column prop="publish_time" :label="pubdate" width="140">
          <template slot-scope="scope">
            <span style="padding:'0px'">{{ scope.row.publish_time.substring(0,11) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" :label="type" width="140"></el-table-column>
        <el-table-column :label="operate" :formatter="formatter">
          <!-- slot-scope="scope"获取表格的数据 scope.row.type 是获取每行的参数 scope.$index 是获取下标-->
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="clickbutton(scope.row.noticeId)"
              width="100"
              :style="but1"
            >{{watch}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="link-top3"></div>
      <el-button class="elbutton" type="text" plain @click="clickhref" :style="but2">{{back}}</el-button>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { stringify } from 'querystring';
import axios from 'axios'; // 导入http中创建的axios实例

export default {
  data() {
    //常量
    // let constant = JSON.parse(this.$supMainPageConfig).constant;
    // this.categorys = JSON.parse(this.$supMainPageConfig).sysShow.info;
    // this.theme = JSON.parse(this.$supMainPageConfig).catItemImg.info7.theme;
    return {
      //多语言
      // moreannouncement: constant.moreannouncement,
      // type: constant.type,
      // time: constant.time,
      // back: constant.back,
      // state: constant.state,
      // title: constant.title,
      // puborg: constant.puborg,
      // pubdate: constant.pubdate,
      // operate: constant.operate,
      // watch: constant.watch,

      filter: {
        type: "",
        publish_time: ""
      },
      currentPage: 1,
      pageSize: 15,
      //allData: this.categorys,
      show: true,
      // showT: this.theme,
      // options: [
      //   {
      //     value: JSON.parse(this.$supMainPageConfig).constant.allannouncement,
      //     label: JSON.parse(this.$supMainPageConfig).constant.allannouncement
      //   },
      //   {
      //     value: JSON.parse(this.$supMainPageConfig).constant.recruitannouncement,
      //     label: JSON.parse(this.$supMainPageConfig).constant.recruitannouncement
      //   },
      //   {
      //     value: JSON.parse(this.$supMainPageConfig).constant.industrydynamic,
      //     label: JSON.parse(this.$supMainPageConfig).constant.industrydynamic
      //   },
      //   {
      //     value: JSON.parse(this.$supMainPageConfig).constant.sysannouncement,
      //     label: JSON.parse(this.$supMainPageConfig).constant.sysannouncement
      //   },
      //   {
      //     value: JSON.parse(this.$supMainPageConfig).constant.winningannouncement,
      //     label: JSON.parse(this.$supMainPageConfig).constant.winningannouncement
      //   },
      //   {
      //     value: JSON.parse(this.$supMainPageConfig).constant.tenderannouncement,
      //     label: JSON.parse(this.$supMainPageConfig).constant.tenderannouncement
      //   }
      // ],
      value: JSON.parse(this.$supMainPageConfig).constant.allannouncement
    };
  },

  watch: {
    supMainPageConfig: function(newV, oldV) {
      this.value = JSON.parse(this.supMainPageConfig).constant.allannouncement;
    }
  },

  
  computed: {
    //store里面取数据
    ...mapGetters(["supMainPageConfig"]),
    moreannouncement: function() {
      return JSON.parse(this.supMainPageConfig).constant.moreannouncement;
    },
    type: function() {
      return JSON.parse(this.supMainPageConfig).constant.type;
    },
    time: function() {
      return JSON.parse(this.supMainPageConfig).constant.time;
    },

    back: function() {
      return JSON.parse(this.supMainPageConfig).constant.back;
    },
    state: function() {
      return JSON.parse(this.supMainPageConfig).constant.state;
    },
    title: function() {
      return JSON.parse(this.supMainPageConfig).constant.title;
    },
    puborg: function() {
      return JSON.parse(this.supMainPageConfig).constant.puborg;
    },
    pubdate: function() {
      return JSON.parse(this.supMainPageConfig).constant.pubdate;
    },

    operate: function() {
      return JSON.parse(this.supMainPageConfig).constant.operate;
    },
    watch: function() {
      return JSON.parse(this.supMainPageConfig).constant.watch;
    },
    allData: function() {
      return JSON.parse(this.supMainPageConfig).sysShow.info;
    },
    showT: function() {
      return JSON.parse(this.supMainPageConfig).catItemImg.info7.theme;
    },

    allannouncement: function() {
      return JSON.parse(this.supMainPageConfig).constant.allannouncement;
    },

    options: function() {
      const optionsData = [
        {
          value: JSON.parse(this.supMainPageConfig).constant.allannouncement,
          label: JSON.parse(this.supMainPageConfig).constant.allannouncement
        },
        {
          value: JSON.parse(this.supMainPageConfig).constant.recruitannouncement,
          label: JSON.parse(this.supMainPageConfig).constant.recruitannouncement
        },
        {
          value: JSON.parse(this.supMainPageConfig).constant.industrydynamic,
          label: JSON.parse(this.supMainPageConfig).constant.industrydynamic
        },
        {
          value: JSON.parse(this.supMainPageConfig).constant.sysannouncement,
          label: JSON.parse(this.supMainPageConfig).constant.sysannouncement
        },
        {
          value: JSON.parse(this.supMainPageConfig).constant.winningannouncement,
          label: JSON.parse(this.supMainPageConfig).constant.winningannouncement
        },
        {
          value: JSON.parse(this.supMainPageConfig).constant.tenderannouncement,
          label: JSON.parse(this.supMainPageConfig).constant.tenderannouncement
        }
      ];
      return optionsData;
    },
    // value: function() {
    //   return JSON.parse(this.$supMainPageConfig).constant.allannouncement;
    // },

    tableData: function() {
      return this.allData.filter(item => {
        if (
          this.value == JSON.parse(this.supMainPageConfig).constant.allannouncement
        ) {
          if (item.type && item.type.includes(this.value)) {
            return false;
          }
        } else {
          if (!(item.type && item.type.includes(this.value))) {
            return false;
          }
        }

        if (this.filter.publish_time) {
          if (
            !(
              item.publish_time &&
              item.publish_time.includes(this.filter.publish_time)
            )
          ) {
            return false;
          }
        }
        return true;
      });
    },
    pageData: function() {
      return this.tableData.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    },
    but1: function() {
      if (this.showT == 1) {
        return {
          color: " #4a98ff"
        };
      }
      if (this.showT == 2) {
        return {
          color: " #6869FB"
        };
      }
      if (this.showT == 3) {
        return {
          color: " #29C392"
        };
      }
      if (this.showT == 4) {
        return {
          color: " #FC8555"
        };
      }
    },
    but2: function() {
      if (this.showT == 1) {
        return {
          color: "#ffffff",
          background: "linear-gradient(90deg,#4a98ff 0%,#4a98ff 100%)",
          width: "100px",
          height: "40px"
        };
      }
      if (this.showT == 2) {
        return {
          color: "#ffffff",
          background: "linear-gradient( 90deg, #6869FB 0%,#6869FB 100%)",
          width: "100px",
          height: "40px"
        };
      }
      if (this.showT == 3) {
        return {
          color: "#ffffff",
          background: "linear-gradient( 90deg, #29C392 0%,#29C392 100%)",
          width: "100px",
          height: "40px"
        };
      }
      if (this.showT == 4) {
        return {
          color: "#ffffff",
          background: "linear-gradient( 90deg, #FC8555 0%,#FC8555 100%)",
          width: "100px",
          height: "40px"
        };
      }
    }
  },
  methods: {
    ...mapMutations['setI18n'],
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
    },
    clickbutton(noticeId) {
      let param = "";
      param = "&noticeId=" + noticeId;
      const base = axios.defaults.baseURL;
      let url = base + "/index.html?formId=quo_notice" + param;
      window.open(url, "_blank");
    },
    clicka(kurl) {
      window.open(kurl);
    },
    clickhref() {
      this.$emit("morefunk", this.show);
      // 退出的时候清空选择
      this.value = null;
      this.filter.publish_time = null;
      this.$forceUpdate();
      this.value = this.options[0].value;
    },
    formatter(row, column) {
      return row.address;
    },
    addclassStatus(status) {
      switch (status) {
        case "15":
          return "statustype";
      }
    }
  }
};
</script>

<style>
.ElementUIS {
  width: 1200px;
  height: 900px;
  background-color: #ffffff;
  margin-left: 310px;
}

.inline {
  margin-top: 20px;
  margin-left: 8px;
  height: 116px;
}

.span {
  margin-right: -70px;
  font-size: 20px;
}

.typelabel {
  margin-top: 20px;
  margin-left: 4px;
}

.time {
  margin-top: 19px;
}

.elbutton {
  margin-top: 7px;
  margin-left: 45%;
  height: 37px;
}

.link-top1 {
  width: 100%;
  height: 1px;
  border-top: 1px solid #acc0d8;
}

.link-top2 {
  width: 100%;
  height: 1px;
  border-top: 1px solid #acc0d8;
}

.link-top3 {
  width: 100%;
  height: 1px;
  border-top: 1px solid #acc0d8;
  margin-top: 10px;
}

.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #f2f6fc !important;
}

.statustype {
  color: rgb(74, 152, 255);
  border: 1px solid rgb(74, 152, 255);
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 118px;
  overflow: hidden;
}
@media screen and (max-width: 1200px) {
  .ElementUIS {
    width: 900px;
  }
}
</style>